<template>
  <header id="header">
    <img class="header-image--greenery" src="../assets/img/global/header-greenery.png" />
    <div class="container">
      <div class="row">
        <div class="col-8">
          <h1 class="logo-clearinghouse">
            <router-link to="/">
              <img src="../assets/img/global/logo-sa-clearinghouse.png" alt="ClearingHouse" />
            </router-link>
          </h1>
        </div>
        <div class="col-4">
          <div class="float-right account">
            <router-link to="/profile" class="account-link">
              <i class="zmdi zmdi-account"></i> <span class="account-link--text">My Account</span>
            </router-link><br />
            <small class="account-sign-out float-right"><a href="#" class="sign-out" @click="onSignOutClick">Sign out</a></small>
          </div>
          <div v-if="authState !== 'signedIn'" class="create-account d-none d-sm-block">
            <button v-if="authState !== 'signUp'" class="btn" @click="onCreateClick">Create account</button>
            <button v-if="authState === 'signUp'" class="btn" @click="onSignInClick">Sign In</button>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapState } from 'vuex'
import { AmplifyEventBus } from 'aws-amplify-vue';
import { Auth } from 'aws-amplify';
import router from '../routes/router';
import routeNames from '../util/routeNames';

export default {
  name: 'Header',
  data() {
    return {};
  },
  computed: {
    ...mapState([
      'authState',
    ]),
  },
  methods: {
    onCreateClick(event) {
      event.preventDefault();
      AmplifyEventBus.$emit('authState', 'signUp');
    },
     onSignInClick(event) {
      event.preventDefault();
      AmplifyEventBus.$emit('authState', 'signIn')
    },
    onSignOutClick: async function (event) {
      event.preventDefault();
      console.log("you're signing out");
      await Auth.signOut();
      this.$store.dispatch('logout');
      router.push(routeNames.AUTH.PATH);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/vendor/_bootstrap-setup";
@import "../styles/environment/_variables";

header#header {
  height: 100px;
  position: relative;
  z-index: 5;

  > .container {
    height: 100%;

    > .row {
      height: 100%;
    }
  }

  .header-image--greenery {
    position: absolute;
    left: 58%;
    top: -8px;
    transform: translateX(-50%);
    z-index: -1;

    //TODO: shouldn't need this
    @include media-breakpoint-down(sm) {
      left: 50%;
      top: -20px !important;
      height: 60px !important;
    }

    @include media-breakpoint-down(md) {
      top: -30px;
      height: 80px;
    }

    @include media-breakpoint-down(lg) {
      top: -15px;
      height: 105px;
    }
  }

  .logo-clearinghouse {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    text-decoration: none;

    img {
      width: 240px;
      
      @include media-breakpoint-up(lg) {
        width: 280px;
      }

      @include media-breakpoint-up(lg) {
        width: 320px;
      }
    }
  }

  .create-account {
    float: right;
    position: relative;
    top: 50%;
    transform: translateY(-50%);

    > .btn {
      border: 1px solid $sa-red-light;
      box-shadow: 0px 0px 0px 4px $sa-red;
      transition: all 0.2s ease-out;

      &:hover {
        background-color: $sa-red-hover;
        box-shadow: 0px 0px 0px 4px $sa-red-hover;
        color: $sa-white;
        opacity: 1;
      }
    }
  }

  .account {
    padding-top: 40px;
    color: $sa-red;
    font-size: $font-size-standard;
    font-weight: $font-main-semibold;
    text-transform: uppercase;

    .account-link {
      position: relative;

      .zmdi {
        color: $sa-red-dark;
        font-size: 25px;
        left: -25px;
        position: absolute;
        top: -4px;

        @include media-breakpoint-down(xs) {
           font-size: 33px;
           top: -6px;
        }
      }
    }

    .account-sign-out {
      text-transform: none;

      a {
        color: $sa-red-dark;
        text-align: right;
      }
    }

    .account-link--text,
    .account-sign-out {
      @include media-breakpoint-down(xs) {
        display: none; 
      }
    }


    :hover {
      color: $sa-cool-gray;
      text-decoration: underline;
    }
  }
}
</style>
